var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"description-markdown",domProps:{"innerHTML":_vm._s(_vm.markdown_rendered)}})
}
var staticRenderFns = []

export { render, staticRenderFns }